import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomConfirmDialogService } from 'src/app/services/Non-Master/CustomConfirmDialog.service';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { tItemCateService } from 'src/app/services/tItemCate.service';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import { tItemCateModel } from 'src/app/models/tItemCateModel';
import { MastersKeyStringValue } from 'src/app/services/Non-Master/MastersKeyStringValue.service';
import { AppSettings } from 'src/app/shared/AppSettings';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppComponent } from 'src/app/app.component';
import { SystemDefaultModel, ChineseDefaultModel, EnglishDefaultModel } from 'src/app/models/non-master-model/SystemDefaultModel';

@Component({
  selector: 'app-search-item-cate-dialog',
  templateUrl: './search-item-cate-dialog.component.html',
  styleUrls: ['./search-item-cate-dialog.component.css']
})
export class SearchItemCateDialogComponent implements OnInit {

  selectedRowIndex: number = -1;
  itemCostList;

  constructor(
    public activeModal: NgbActiveModal,
    private router: Router,
    private customConfirmDialogService: CustomConfirmDialogService,
    private log: LoggerService,
    private route: ActivatedRoute,
    private tItemCateService: tItemCateService) { }

    displayedColumns: string[] = [
      // 'action_button_title',
      'itemCateID',
      'itemCateName',
      // 'itemCateName2',
      'isStock',
      'isServiceType',
      'itemCostMethod',
      // 'accCode',
      // 'accName',
      // 'applyShop',
      // 'itemCateRemark1',
      // 'lastModifyDatetime',
      // 'lastModifyUserID',
      // 'inActive'
    ];
  
    dataSource: MatTableDataSource<tItemCateModel>;
    dataList: tItemCateModel[];


    @ViewChild(MatPaginator) paginator: MatPaginator;
  
    TAG = 'SearchItemCateDialogComponent';
    // displayMsg: string;
    @Input() action: string;
    @Input() status: string;
    @Input() tableKeyValue: string;
    @Input() msg: string;

    ngOnInit() {

      this.setDefaultLanguageString(AppComponent.usingLanguage);

      this.getAllData();
    }

    getAllData(): void {
      this.tItemCateService.getAllData().subscribe(data => {
        this.dataList = data;

        this.dataSource = new MatTableDataSource<tItemCateModel>(data);
        this.dataSource.paginator = this.paginator;
        // console.log('getAllData = ' + JSON.stringify(this.dataSource));
        // this.dataSource.filterPredicate =
        //   (data: tItemCateModel, filter: string) => (data.itemCateID.indexOf(filter) != -1);
      });
    }

    applyFilter(filterValue: string) {
      this.dataSource.filter = filterValue.trim().toLowerCase()
    }

    selectRow(selectedModel: tItemCateModel, index: number) {

      this.log.i(this.TAG, selectedModel.itemCateID.toString());

      this.selectedRowIndex = index;

      switch (this.tableKeyValue) {
        case MastersKeyStringValue.TABLE_ItemCate:
          this.tItemCateService.shareSelected(selectedModel);
          break;
        case MastersKeyStringValue.TABLE_PriceBook:
          // this.tItemCateService.priceBookShareSelected(selectedModel);
          break;
        default:
          this.tItemCateService.shareSelected(selectedModel);
          break;
      }



      this.activeModal.close(selectedModel);
    }

    setDefaultLanguageString(language: String){
      switch(language) {
        case SystemDefaultModel.Language_Chinese:
            this.itemCostList = ChineseDefaultModel.ItemCalcByList;
          break;
        case SystemDefaultModel.Language_English:
            this.itemCostList = EnglishDefaultModel.ItemCalcByList;
          break;
        default:
            this.itemCostList = ChineseDefaultModel.ItemCalcByList;
          break;
      }
    }



}
